<template>
    <div class="calendar">
        <div class="calendar-header">
            <div class="date">{{day.year()}}年 {{day.month() + 1}}月<span style="display: none">{{cnt}}</span></div>
            <div class="buttons">
                <span class="today-button cursor-pointer" @click="setToday">今日</span>
                <span class="prev-button cursor-pointer" @click="prev">
                    <img src="../assets/icon/arrow-left-circle.png" alt="">
                </span>
                <span class="next-button cursor-pointer" @click="next">
                    <img src="../assets/icon/arrow-right-circle.png" alt="">
                </span>
            </div>
        </div>
        <div class="calendar-body">
            <div>
                <span
                   v-for="(day, index) in dayOfWeekText"
                   :key="index"
                   class="date-cell cursor-pointer">{{day}}
                </span>
            </div>
            <div v-for="(week, index) in weeks" :key="index">
                <div>
                   <span v-for="(day, index2) in week"
                         :key="index2"
                         class="date-cell cursor-pointer"
                         @click="selectDay(day, index)"
                         :class="{'not-in-current-month': !isCurrentMonth(day, index), 'today': isToday(day), 'is-selected': checkSelectedDay(day, index)}">
                       {{day}}
                   </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'

export default {
  props: {
    autoSetToday: {type: Boolean, required: false, default: false},
    todayText: {type: String, required: false, default: 'Today'},
    nextText: {type: String, required: false, default: 'Next'},
    prevText: {type: String, required: false, default: 'Prev'},
    meeting: {type: Object, required: false},
  },
  data () {
    return {
      dayOfWeekText: ['日', '月', '火', '水', '木', '金', '土'],
      cnt: 0,
      day: moment(),
      today: moment(),
      selectedDay: null,
      weeks: []
    }
  },
  methods: {
    setToday () {
      this.weeks = []
      this.day = moment()
      this.cnt = 0
      const firtWeekDays = this.getFirtWeekDays()
      const lastWeekDays = this.getLastWeekDays()
      this.weeks = this.getWeekDays(firtWeekDays, lastWeekDays)
      this.selectDay(moment().date())
    },
    prev () {
      this.weeks = []
      this.day = this.day.subtract(1, 'M')
      this.cnt++

      const firtWeekDays = this.getFirtWeekDays()
      const lastWeekDays = this.getLastWeekDays()
      this.weeks = this.getWeekDays(firtWeekDays, lastWeekDays)
    },
    next () {
      this.weeks = []
      this.day = this.day.add(1, 'M')
      this.cnt++

      const firtWeekDays = this.getFirtWeekDays()
      const lastWeekDays = this.getLastWeekDays()
      this.weeks = this.getWeekDays(firtWeekDays, lastWeekDays)
    },
    checkSelectedDay(day, index) {
      return this.isCurrentMonth(day, index) && this.isSelectedDay(day)
    },
    getFirtWeekDays () {
      const todayCopy = _.cloneDeep(this.day)
      const startOfMonth = todayCopy.startOf('month')
      const endOfPrevMonth = todayCopy.subtract(1, 'M').endOf('month')
      let week = []
      if (endOfPrevMonth.day() !== 6) {
        for (let i = 0; i < startOfMonth.day() + 1; i++) {
          week.push(endOfPrevMonth.date() - i)
        }
        week.reverse()
        for (let i = 0; i < 6 - startOfMonth.day(); i++) {
          week.push(i + 1)
        }
      }
      return week
    },
    getLastWeekDays () {
      const todayCopy = _.cloneDeep(this.day)
      const endOfMonth = todayCopy.endOf('month')
      let week = []
      for (let i = 0; i < endOfMonth.day() + 1; i++) {
        week.push(endOfMonth.date() - i)
      }
      week.reverse()
      for (let i = 0; i < 6 - endOfMonth.day(); i++) {
        week.push(i + 1)
      }
      return week
    },
    getWeekDays (firtWeekDays, lastWeekDays) {
      const start = firtWeekDays.length === 0 ? 0 : firtWeekDays[6]
      const end = lastWeekDays.length === 0 ? moment().endOf('month').date() + 1 : lastWeekDays[0]
      let weeks = []
      let week = []
      for (let i = start + 1; i < end; i++) {
        week = [...week, i]
        if (week.length === 7) {
          weeks = [...weeks, week]
          week = []
        }
      }
      return [firtWeekDays, ...weeks, lastWeekDays]
    },
    isCurrentMonth (day, weekIndex) {
      if (weekIndex === 0 && day > 7) return false
      if (weekIndex > 1 && day <= 7) return false
      return true
    },
    isToday (day) {
      return (this.today.year() === this.day.year() && this.today.month() === this.day.month() && this.today.date() === day)
    },
    isSelectedDay (day) {
      return (this.selectedDay &&
        moment(this.selectedDay).year() === this.day.year() &&
        moment(this.selectedDay).month() === this.day.month() &&
        moment(this.selectedDay).date() === day)
    },
    selectDay (day, weekIndex = null) {
      if (weekIndex === 0 && day > 7) {
        this.prev()
        this.selectDay(day)
      } else if (weekIndex > 1 && day <= 7) {
        this.next()
        this.selectDay(day)
      } else {
        this.selectedDay = _.cloneDeep(this.day)
        this.selectedDay.date(day)
        this.$emit('dateChanged', this.selectedDay)
      }
    }
  },
  mounted () {
    const firtWeekDays = this.getFirtWeekDays()
    const lastWeekDays = this.getLastWeekDays()
    this.weeks = this.getWeekDays(firtWeekDays, lastWeekDays)
    if (this.autoSetToday) this.setToday()
    if (this.$route.name === 'meetings.edit') {
      this.selectedDay = this.meeting.start_at
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CalendarOnlineMeeting.vue